export function handleWebsocketClose(closeEvent, currentPath) {
  console.log('disconnected');
  console.log(closeEvent);
  console.log(closeEvent.reason);

  // Check if user is authenticated - if not, don't redirect (they should be on login page)
  const token = localStorage.getItem('jwt_token');

  const redirectBase =
    window.config && window.config.REACT_APP_REDIRECT
      ? window.config.REACT_APP_REDIRECT
      : '/';
  const loginRoute = `${redirectBase}ui/login`;
  const reason = closeEvent?.reason?.toLowerCase?.() || '';
  const invalidAuth =
    closeEvent?.code === 1003 || reason.includes('invalid authentication token');
  const authPages = ['/ui/login', '/ui/forgot-password', '/ui/reset-password'];
  const onAuthPage = authPages.includes(window.location.pathname);

  if (invalidAuth) {
    console.log('WebSocket closed due to invalid auth, clearing credentials.');
    localStorage.removeItem('jwt_token');
    localStorage.removeItem('username');

    if (!token || onAuthPage) {
      console.log('Already on auth page (or no token) after invalid token - not redirecting again.');
      return;
    }

    window.location.replace(loginRoute);
    return;
  }

  if (!token) {
    console.log('WebSocket closed but user not authenticated - staying on current page');
    return;
  }
  if (onAuthPage) {
    console.log('WebSocket closed on auth page - token exists but skipping redirect to avoid loops.');
    return;
  }

  // If authenticated but WebSocket closed, redirect to backend
  let redirectRoute = '';
  const redirectPath = currentPath === '/ui/alerts' ? 'alerts' : '';
  if (window.config && window.config.REACT_APP_REDIRECT) {
    redirectRoute = window.config.REACT_APP_REDIRECT + redirectPath;
  } else {
    redirectRoute = 'http://localhost:8080/' + redirectPath;
  }
  window.location.replace(redirectRoute);
}
